;(function (angular, moment) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('format', FormatFilter)

  FormatFilter.$inject = []

  function FormatFilter () {
    var status = function (val) {
      switch (val) {
        case 'cancelled':
          return 'Intervention annulée'
        case 'completed-with-problems':
          return 'Intervention terminée avec incident'
        case 'in-progress':
          return 'Intervention en cours'
        case 'completed':
          return 'Intervention terminée avec succès'
        case 'planned':
          return 'Intervention prévue'
        case 'in-transit':
          return 'Trajet en cours'
        case 'paused':
          return 'Intervention en pause'
        default:
          return ''
      }
    }

    var handle = function (input, type) {
      if (!input) return
      if (Array.isArray(input)) {
        return input.map(function(i){return handle(i, type)}).join(', ')}
      switch (type) {
        case 'technician':
          return input.fullname || input
        case 'duration':
          var str = ''
          var d = moment.duration(parseInt(input))
          if (d.days()) {
            str += d.days() + ' jours '
          }
          if (d.hours()){
            str += d.hours() + ' heures '
          }

          if (d.minutes()){
            str += d.minutes() + ' minutes '
          }
          if (!str.length) {
            return '0 minutes'
          }
          return str
        case 'date':
          return moment(new Date(input)).format('DD/MM/YYYY - HH:mm')
        case 'status':
          return status(input)
        default:
          return input
      }
    }
    return handle
  }
})(window.angular, window.moment)
